import { createSelector } from '@ngrx/store';

import * as fromCostBasis from '../../reducers/cost-basis/cost-basis.reducer';
import * as fromFeature from '../../reducers/index';

export const selectCostBasisState = createSelector(fromFeature.getCostBasis, (state) => state);

export const selectSelectedPositions = createSelector(
  selectCostBasisState,
  fromCostBasis.getSelectedPositions,
);
export const selectCostBasisHoldingsMethod = createSelector(
  selectCostBasisState,
  fromCostBasis.getCostBasisHoldingsMethod,
);
export const selectCostBasisLots = createSelector(
  selectCostBasisState,
  fromCostBasis.getCostBasisLots,
);
